import styled from 'styled-components';

// Interstate composes its part ids as `ids-modal-<part>-<modalId>` and exposes no prop that suppresses
// the close control, so these selectors must be derived from the id the modal was given.
export const buildRetentionModalCss = ({ modalId, hideCloseButton }: { modalId: string; hideCloseButton: boolean }): string => `
    #ids-modal-content-${modalId} {
        overflow-y: hidden;
    }
    #ids-modal-root-${modalId} .ids-modal-footer .ids-action-buttons-container-rightAligned {
        flex-wrap: wrap;
    }
    ${hideCloseButton ? `#ids-modal-close-button-${modalId} { display: none; }` : ''}
`;

export const StyledVehicleComparison = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.tokens.BaseSpace40};
    margin-bottom: ${({ theme }) => theme.tokens.BaseSpace60};
`;

export const StyledVehicleCard = styled.div<{ $variant?: 'current' | 'new' }>`
    flex: 1;
    min-width: 0;
    border: 1px solid ${({ theme }) => theme.tokens.SemColorBorderMuted};
    border-radius: ${({ theme }) => theme.tokens.BaseSizeBorderRadiusSm};
    padding: ${({ theme }) => `${theme.tokens.BaseSpace30} ${theme.tokens.BaseSpace40}`};
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.tokens.BaseSpace10};
    background-color: ${({ $variant, theme }) => ($variant === 'current' ? theme.tokens.SemColorSurfaceSubdued : 'transparent')};

    .vehicle-description {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export const StyledArrowSeparator = styled.div`
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.tokens.BaseColorGray600};
`;

export const StyledDealDetailsHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.tokens.BaseSpace40};
`;

export const StyledDealDetailsSeparator = styled.hr`
    border: none;
    border-top: 1px solid ${({ theme }) => theme.tokens.SemColorBorderMuted};
    margin-bottom: ${({ theme }) => theme.tokens.BaseSpace40};
`;

export const StyledCategorySection = styled.div`
    margin-bottom: ${({ theme }) => theme.tokens.BaseSpace20};
`;

export const StyledCategoryHeader = styled.div`
    margin-bottom: ${({ theme }) => theme.tokens.BaseSpace20};
`;

export const StyledItemRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme }) => `${theme.tokens.BaseSpace15} 0`};
`;

export const StyledItemLabel = styled.span`
    flex: 1;
`;

export const StyledKeepCheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.tokens.BaseSpace20};
`;

export const StyledModalBody = styled.div`
    max-height: 60vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: ${({ theme }) => theme.tokens.BaseSpace40};
`;
